// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.contract-dialog {\r\n  margin-top: 5vh !important;\n}\n.contract-dialog .el-dialog__body {\r\n  padding: 10px 20px 20px;\n}\r\n", ""]);
// Exports
module.exports = exports;
